import { defineComponent, ref } from 'vue';
import Warning from '../../../../../../../assets/icons/warning-2.svg.js';
import __vue_component__$2 from '../../../../../../alerts/Pane/Pane.vue.js';
import __vue_component__$1 from '../../../../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__ from '../../../../../../cards/BasicCard/BasicCard.vue.js';

var script = defineComponent({
    name: 'ChartingHospitalConfirm',
    components: {
        BasicCard: __vue_component__,
        ButtonComponent: __vue_component__$1,
        Pane: __vue_component__$2,
        Warning,
    },
    props: {
        isOpened: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['hospitalConfirmed', 'update:isOpened'],
    setup: (_, { emit }) => {
        const confirmed = ref(null);
        const paneRef = ref();
        const handleConfirm = (value) => {
            var _a;
            confirmed.value = value;
            if (!((_a = paneRef.value) === null || _a === void 0 ? void 0 : _a.closeModal))
                return;
            paneRef.value.closeModal();
        };
        const handleClose = () => {
            emit('hospitalConfirmed', confirmed.value);
            confirmed.value = null;
            emit('update:isOpened', false);
        };
        return {
            paneRef,
            handleClose,
            handleConfirm,
        };
    },
});

export { script as default };
